import React, { useMemo } from 'react';

export default function ParticleField({ count = 90 }) {
  const particles = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => {
      const size = Math.random() * 6 + 2;
      const left = Math.random() * 100;
      const bottom = Math.random() * 100 - 20;
      const duration = 14 + Math.random() * 22;
      const delay = -Math.random() * 30;
      const opacity = 0.35 + Math.random() * 0.55;
      const isGold = Math.random() < 0.22;
      return { size, left, bottom, duration, delay, opacity, isGold, id: i };
    });
  }, [count]);

  return (
    <div className="particles-bg">
      {particles.map((p) => (
        <span
          key={p.id}
          className={`particle ${p.isGold ? 'gold' : ''}`}
          style={{
            width: `${p.size}px`,
            height: `${p.size}px`,
            left: `${p.left}%`,
            bottom: `${p.bottom}%`,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
            opacity: p.opacity,
          }}
        />
      ))}
    </div>
  );
}
